module.exports = "../dist/frontend/icons/benefits/green/face-id.svg?4a6df38295847620d20b2d4711202fd1";